module.exports = __webpack_public_path__ + "static/media/light-start.23d3fc19.svg";